<template>
	<form class="checkout-zip">
		<template v-if="hasZipCode && ! changingZipCode && deliveryOption !== 1">
			<span class="current-zip">
				{{ usingZipCode }} {{ zipCodeCity }}
				<a class="change-zip" @click.prevent.stop="changeZipCode">Ändra?</a>
			</span>
		</template>
		<template v-else>
			<label
				v-if="deliveryOption !== 1"
				for="zip"
			>
				Fyll i ditt postnummer för att visa fraktalternativ
			</label>
			<location-search
				v-if="deliveryOption === 1"
				@locationChanged="locationChanged"
				:gettingZipCode="true"
				:autofocus="false"
				:restrictToSweden="true"
				:increaseHeight="true"
			/>
			<input-text
				v-else
				v-model="inputZipCode"
				id="zip"
				glyphicon="map-marker"
				pattern="[0-9]*"
				placeholder="Postnummer"
				type="number"
				inputmode="numeric"
				hide-valid name="zip"
				autofocus
				:triggerFocus="autoFocus"
				:increaseHeight="true"
			/>
		</template>
	</form>
</template>

<script>
import alert from 'alert';
import { mapState } from 'vuex';
import cityByZip from 'utils/cityByZip';

export default {
	data() {
		return {
			autoFocus: false,
			usingZipCode: '',
			inputZipCode: '',
			zipCodeCity: null,
			changingZipCode: false,
			location: {},
		};
	},
	props: {
		deliveryOption: {
			type: Number,
			required: false,
			default: 0,
		},
		zipCode: {
			type: Number,
		},
	},
	methods: {
		changeZipCode () {
			this.changingZipCode = true;
			this.usingZipCode = '';
			this.inputZipCode = '';
			this.usingZipCode = '';
		},
		updateZipCity (zip) {
			this.zipCodeCity = '';
			cityByZip(zip, city => {
				this.zipCodeCity = city;
			});
		},
		locationChanged (place) {
			if (this.deliveryOption === 1) {
				if (! place || ! place.geometry) {
					return;
				}
				const loc = place.geometry.location;
				this.location = {
					lat: loc.lat(),
					lng: loc.lng(),
				};

				this.$nextTick(() => {
					this.$emit('setLocation', this.location);
				});
			} else {
				let zipcode = null;
				switch (place.types[0]) {
					case 'street_address' || 'premise':
						zipcode = place.address_components[6].long_name;
						break;
					case 'postal_code':
						zipcode = place.address_components[0].long_name;
						break;
					case 'establishment':
						zipcode = place.address_components[4].long_name;
						break;
					default:
						alert('Vänligen ange ett giltigt postnummer');
						break;
				}

				if (typeof zipcode === 'string') {
					zipcode = zipcode.split(' ').join('');
					this.inputZipCode = zipcode;
				}
			}
		},
	},
	mounted () {
		if (this.user.zipCode && this.user.zipCode.length >= 5 && this.deliveryOption !== 1) {
			this.inputZipCode = this.user.zipCode;
		} else if (this.zipCode) {
			this.inputZipCode = this.zipCode.toString();
		} else {
			this.$nextTick(() => {
				this.autoFocus = true;
			});
		}
	},
	computed: {
		hasZipCode () {
			return this.usingZipCode.length >= 5;
		},
		...mapState({
			user: state => state.user,
		}),
	},
	watch: {
		inputZipCode (to, frm) {
			const inputZipCode = (to || '').replace(/[^0-9]/g, '').substr(0, 5);
			if (inputZipCode.length === 5) {
				this.usingZipCode = inputZipCode;
				this.changingZipCode = false;
			}
			this.$nextTick(() => {
				this.inputZipCode = inputZipCode;
			});
		},
		usingZipCode (to, frm) {
			const usingZipCode = (to || '').replace(/[^0-9]/g, '').substr(0, 5);
			if (usingZipCode.length === 5) {
				// if (! this.customerInfo.zip_code) {
				// 	this.customerInfo.zip_code = usingZipCode;
				// }

				this.zipCodeCity = '';
				if (this.changingZipCode && (this.inputZipCode.length === 0 || this.inputZipCode.length >= 5)) {
					this.changingZipCode = false;
				}

				if (usingZipCode !== frm) {
					this.updateZipCity(usingZipCode);
				}
			}
			this.$nextTick(() => {
				this.usingZipCode = usingZipCode;
				this.$emit('updateZip', usingZipCode === '' ? 0 : usingZipCode);
				// this.getShippingMethods();
			});
		},
	},
};
</script>
